export const DIRECTION_DELIVERY = "road_to_rail";
export const DIRECTION_PICKUP = "rail_to_road";
export const CARRIER_BOOKED_ORDER = "CARRIER_BOOKED_ORDER";
export const LOADED_AT_SENDER = "LOADED_AT_SENDER";
export const ARRIVED_BY_ROAD = "ARRIVED_BY_ROAD";
export const CARRIER_LOADED_ON_RAIL = "CARRIER_LOADED_ON_RAIL";
export const DELIVERED_TO_TERMINAL = "DELIVERED_TO_TERMINAL";
export const CARRIER_BOOKED_ARRIVAL = "CARRIER_BOOKED_ARRIVAL";
export const CARRIER_BOOKED_PICKUP = "CARRIER_BOOKED_PICKUP";
export const COUNTER_CANCELLATION_NEEDED = "COUNTER_CANCELLATION_NEEDED";
export const NOT_DEPARTED_BY_RAIL = "NOT_DEPARTED_BY_RAIL";
export const CARRIER_DEPARTED_BY_RAIL = "CARRIER_DEPARTED_BY_RAIL";
export const CARRIER_ARRIVED_BY_RAIL = "CARRIER_ARRIVED_BY_RAIL";
export const COLLECTING_TRUCK_ARRIVED = "COLLECTING_TRUCK_ARRIVED";
export const PICKED_UP_AT_TERMINAL = "PICKED_UP_AT_TERMINAL";
export const DELIVERED_TO_CONSIGNEE = "DELIVERED_TO_CONSIGNEE";
export const CANCELLATION_REQUESTED = "CANCELLATION_REQUESTED";
export const UNASSIGNED = "UNASSIGNED";
export const DRIVER = "DRIVER";
export const TOUR = "TOUR";
export const DONE = "DONE";

export const loadingUnitRegex = /^$|^([a-zA-Z]){2,4}([0-9]){7,12}$/; // empty string or pattern
export const containerTypeRegex = /\w+/; // at least some alpha character, checks that something is selected
export const heightCodeRegex = /\d+/; // same as above
export const weightRegex = /^[0-9]((\d{0,1}\.\d{3})|\d{0,4})$/;
export const licensePlateRegex = /^[,/\\\s-]*(?:[0-9a-zA-Z][,/\\\s-]*){3,}$/;

export const COOKIE_USERNAME = "username";
export const COOKIE_TOKEN = "loginToken";
export const COOKIE_DATA = "userData";
export const COOKIE_TERMS_ACCEPTED = "termsAccepted";
